import React from 'react';
import { Route, Switch, withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import LoginRequiredRoute from 'components/LoginRequiredRoute/LoginRequiredRoute';

import AuthLayout from "layouts/Auth/Auth.jsx";
import AdminLayout from "layouts/Admin/Admin.jsx";

class App extends React.Component {
    componentDidMount() {
        // setTimeout(() => { this.props.changeLoggedIn(false) }, 2000);
    }

    render() {
        // if (this.props.loggedIn === undefined) {
        //     return <Loader/>
        // }

        return (
            <Switch>
                <Route path="/auth" render={props => <AuthLayout {...props} />} />
                <LoginRequiredRoute component={AdminLayout} />
            </Switch>
        )
    }
}

export default withRouter(connect(
    state => ({
        loggedIn: state.login.loggedIn,
    })
)(App));